module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-14-80b10e50ce5ec640fcc2fe1bf27a5864.svg";